// Дерево "чемпионаты -> лиги" из POST /leagues/adminLeagueStructure.
// Сервер уже отдаёт только данные текущего админа, здесь — нормализация полей.

const FAKE_LEAGUE_IDS = [-1, -2];

// Бэкенд часто перезаписывает лого по тому же пути — браузер тогда
// держит старый файл в кэше. После смены лого сбрасываем кэш query-параметром.
const leagueLogoBust = {};

export const bumpLeagueLogoCache = (leagueId) => {
  if (leagueId == null) return;
  leagueLogoBust[Number(leagueId)] = Date.now();
};

export const leagueLogoCacheBust = (leagueId) => (
  leagueId == null ? 0 : (leagueLogoBust[Number(leagueId)] || 0)
);

export const byPriorityThenName = (a, b) => {
  const pa = a.priority !== undefined && a.priority !== null ? a.priority : 9999;
  const pb = b.priority !== undefined && b.priority !== null ? b.priority : 9999;
  if (pa !== pb) return pa - pb;
  return (a.name || '').localeCompare(b.name || '', 'ru');
};

export const seasonSettingsFrom = (season) => {
  const src = season && season.settings ? season.settings : (season || {});
  return {
    league_type: Number(src.league_type) === 2 ? 2 : 1,
    group_stages_amount: src.group_stages_amount !== undefined
      ? src.group_stages_amount : null,
    application_id: src.application_id !== undefined
      ? src.application_id : null,
    application_active: src.application_active !== undefined
      ? src.application_active : 0,
    rate_ratio: src.rate_ratio !== undefined ? src.rate_ratio : null,
    penalty_draw_score: src.penalty_draw_score !== undefined
      ? src.penalty_draw_score : null,
  };
};

const mapSeason = (season) => {
  const settings = seasonSettingsFrom(season);
  return {
    season_id: Number(season.season_id),
    season_name: season.season_name,
    league_type: settings.league_type,
    settings,
  };
};

const mapLeague = (league, fallbackChampionatId) => {
  const seasons = (league.seasons || [])
    .map(mapSeason)
    .sort((a, b) => (b.season_name || '').localeCompare(a.season_name || '', 'ru'));

  const settings = {};
  seasons.forEach(season => {
    settings[season.season_id] = season.settings;
  });

  const championatId = league.championat_id !== undefined && league.championat_id !== null
    ? Number(league.championat_id)
    : (fallbackChampionatId !== undefined ? fallbackChampionatId : null);

  return {
    id: Number(league.id !== undefined ? league.id : league.league_id),
    name: league.name || league.league_name,
    image: league.image || league.league_image || '',
    championat_id: championatId,
    active_season: league.active_season !== undefined && league.active_season !== null
      ? Number(league.active_season) : null,
    enabled: league.enabled !== undefined ? Number(league.enabled) : 1,
    priority: league.priority,
    seasons: seasons.map(({ season_id, season_name, league_type }) => ({
      season_id, season_name, league_type,
    })),
    settings,
    client_id: league.client_id !== undefined ? Number(league.client_id) : undefined,
  };
};

const isRealLeague = (league) => (
  !FAKE_LEAGUE_IDS.includes(league.id) && !isNaN(league.id)
);

export const buildLeagueStructure = (payload) => {
  const rawChampionats = (payload && payload.championats) || [];
  const rawOrphans = (payload && payload.orphan_leagues) || [];

  const championats = rawChampionats
    .map(ch => ({
      id: Number(ch.id),
      name: ch.name,
      priority: ch.priority,
      image: ch.image,
      client_id: Number(ch.client_id),
      // Логотип клиента, если бэкенд отдаёт его вместе с чемпионатом
      client_image: ch.client_image || (ch.client && ch.client.image) || '',
    }))
    .sort(byPriorityThenName);

  const championatsById = {};
  championats.forEach(ch => { championatsById[ch.id] = ch; });

  const leagues = [];
  rawChampionats.forEach(ch => {
    (ch.leagues || []).forEach(league => {
      leagues.push(mapLeague(league, Number(ch.id)));
    });
  });
  rawOrphans.forEach(league => {
    leagues.push(mapLeague(league, null));
  });

  const uniqueLeagues = [];
  const seenLeagueIds = new Set();
  leagues.filter(isRealLeague).forEach(league => {
    if (seenLeagueIds.has(league.id)) return;
    seenLeagueIds.add(league.id);
    uniqueLeagues.push(league);
  });

  const seasonsCatalog = [];
  const seenSeasons = new Set();
  uniqueLeagues.forEach(league => {
    league.seasons.forEach(season => {
      if (seenSeasons.has(season.season_id)) return;
      seenSeasons.add(season.season_id);
      seasonsCatalog.push({
        season_id: season.season_id,
        season_name: season.season_name,
      });
    });
  });
  seasonsCatalog.sort((a, b) => (b.season_name || '').localeCompare(a.season_name || '', 'ru'));

  const leaguesById = {};
  uniqueLeagues.forEach(league => { leaguesById[league.id] = league; });

  const tree = {};
  championats.forEach(ch => { tree[ch.id] = []; });
  const orphanLeagues = [];

  uniqueLeagues.forEach(league => {
    if (league.championat_id !== null && tree[league.championat_id]) {
      tree[league.championat_id].push(league);
    } else {
      orphanLeagues.push(league);
    }
  });

  Object.keys(tree).forEach(id => tree[id].sort(byPriorityThenName));
  orphanLeagues.sort(byPriorityThenName);

  return {
    championats, championatsById, leagues: uniqueLeagues, leaguesById,
    tree, orphanLeagues, seasonsCatalog,
  };
};
